<h2 mat-dialog-title>
  Mettre à jour le modèle : <b>{{ model.modelName }}</b>
</h2>

<mat-dialog-content>
  <p class="subtitle">
    Version actuelle : <b>{{ model.modelVersion }}</b
    ><br />
    Identifiant : <b>{{ model.id }}</b>
  </p>

  <!-- Hidden file input -->
  <input
    #fileInput
    type="file"
    accept=".xlsx, .xls, .xlsm"
    style="display: none"
    (change)="onFileSelected($event)"
  />

  <button mat-button (click)="fileInput.click()">
    <mat-icon fontSet="material-symbols-outlined">cloud_upload</mat-icon>
    Téléverser un fichier Excel
  </button>

  <div [formGroup]="form">
    <mat-form-field style="width: 300px; margin-top: 0.5rem">
      <mat-label> Nouvelle version du modèle </mat-label>
      <input
        matInput
        [formControlName]="'modelVersion'"
        type="text"
        placeholder="ex: 2.1, beta, RC-1"
      />
      @if (form.get('modelVersion')?.touched &&
      form.get('modelVersion')?.invalid) {
      <mat-hint class="hint">
        <mat-icon fontSet="material-symbols-outlined">error</mat-icon>
        Version requise (caractères autorisés : lettres, chiffres, ., -, _,
        espace)
      </mat-hint>
      }
    </mat-form-field>
  </div>

  @if (form.get('file')!.value) {
  <mat-card appearance="outlined" class="file-card">
    <mat-card-content>
      <div class="hint hint__secondary">
        <mat-icon fontSet="material-symbols-outlined">description</mat-icon>
        {{ form.get("file")!.value?.name }}
      </div>
      <hr />

      @if (!form.get('file')!.valid) {
      <div class="hint">
        <mat-icon fontSet="material-symbols-outlined">error</mat-icon>
        Le fichier inséré n'est pas un fichier Excel (.xls, .xlsx, .xlsm).
        Veuillez réessayer.
      </div>
      } @else if (fileError) {
      <div class="hint">
        <mat-icon fontSet="material-symbols-outlined">error</mat-icon>
        <div>
          <span
            >Le fichier Excel inséré ne respecte pas le format standard :</span
          ><br />
          <b>{{ fileError }}</b>
        </div>
      </div>
      } @else {
      <div class="hint hint__valid">
        <mat-icon fontSet="material-symbols-outlined">check</mat-icon>
        Vérifications OK
      </div>
      }
    </mat-card-content>
  </mat-card>
  }

  <p class="standard-note">
    Le fichier doit suivre le standard à jour. Pour obtenir la dernière version,
    contactez l'administrateur technique
    (nicolas.filizzola&commat;rweality.com).
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Fermer</button>

  <button
    mat-button
    color="primary"
    [disabled]="form.invalid || !!fileError || loading"
    (click)="onSubmit()"
  >
    <mat-icon fontSet="material-symbols-outlined" fontIcon="save"></mat-icon>
    Enregistrer la nouvelle version
  </button>

  <mat-spinner [diameter]="24" *ngIf="loading"></mat-spinner>
</mat-dialog-actions>
